import { useNavigate } from 'react-router-dom';

function DemoSelection({ theme, toggleTheme, setIsDemo, setDemoID, demoID, isDemo }) {
  const navigate = useNavigate();

  const handleSelectDemo = async (id) => {
    setIsDemo(true);
//    console.log(isDemo)
//    console.log(String(id))
    localStorage.setItem('isDemoMode', 'true');
    setDemoID(String(id));
//    console.log(demoID)
    navigate('/dashboard');
  };

  const demos = [
    // {
    //   id: 2,
    //   title: 'Portefeuille de Warren Buffett',
    //   description: 'Réplique du portefeuille de Berkshire Hathaway : focus sur les entreprises solides et durables.',
    //   image: '/images/brk_warrenBuffet.png',
    //   ratio: 100,
    //   lightBg: '#F2F2F2',
    //   darkBg: '#F2F2F2'
    // },
    {
      id: 6,
      title: 'Données Fictives 1',
      description: 'Portefeuille fictif équilibré avec beaucoup d\'ETFs et un mix d\'actions stock picking pour une simulation réaliste.',
      image: '/images/demo_fictive1.png',
      ratio: 100,
      lightBg: '#1F2937',
      darkBg: '#1F2937'
    },
    {
      id: 1,
      title: 'Données Fictives Tech et Luxe',
      description: 'Données fictives agressives avec forte exposition tech et volatilité élevée.',
      image: '/images/Magnificent_Seven_Bourse.png',
      ratio: 100,
      lightBg: '#CCD8E4',  // Fond bleu clair pour un vibe tech
      darkBg: '#CCD8E4'   // Fond bleu foncé en dark mode
    },
    // {
    //   id: 3,
    //   title: 'Portefeuille Technologique',
    //   description: 'Portefeuille complet sur 6 ans : mix défensif/passif/agressif avec focus tech, cash varié (épargne, heritage, aléatoire), transactions random/DCA pour analyse holistique.',
    //   image: '/images/demo_fictive3.png',
    //   ratio: 100,
    //   lightBg: '#1F2937',
    //   darkBg: '#1F2937'
    // },
    {
      id: 4,
      title: 'Portefeuille Diversifié',
      description: 'Portefeuille hybride sur 4 ans : mix agressif (tech/luxe) et passif (ETFs EUR), apports mensuels/heritage, transactions DCA/random pour une allocation équilibrée.',
      image: '/images/demo_fictive2.png',
      ratio: 100,
      lightBg: '#1F2937',
      darkBg: '#1F2937'
    },
    // {
    //   id: 5,
    //   title: 'Portefeuille de Micheal Burry',
    //   description: 'Réplique du portefeuille de Scion Asset Management. (note récente : il a annoncé sa fermeture en novembre 2025)',
    //   image: '/images/sam_michealBurry.png',
    //   ratio: 100,
    //   lightBg: '#0D0D0F',
    //   darkBg: '#0D0D0F'
    // }    
  ];

  return (
    <div className="py-8">
      <div className={`min-h-screen ${theme === 'light' ? 'bg-gray-50' : 'bg-gray-800'} transition-colors duration-300 w-full animate-fade-in`}>
        <div className="w-full px-4 sm:px-6 lg:px-8 py-8">

          {/* Header avec animation subtile */}
          <header className="flex justify-between items-center mb-8 animate-slide-down">
            <h1 className="text-3xl font-semibold text-gray-800 dark:text-gray-100">Sélection de Base Démo</h1>
            <button
              onClick={toggleTheme}
              className="px-3 py-1.5 rounded-md bg-blue-600 text-white hover:bg-blue-700 text-sm transition-all duration-300 hover:scale-105 animate-pulse-slow"
            >
              {theme === 'light' ? 'Mode Sombre' : 'Mode Clair'}
            </button>
          </header>

          {/* Intro avec animation */}
          <section className="text-center mb-12 animate-slide-up">
            <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-gray-100">
              Choisissez une base de données démo
            </h2>
            <p className="text-base text-gray-600 dark:text-gray-300 max-w-2xl mx-auto mb-6">
              Explorez nos portefeuilles fictifs pour tester toutes les fonctionnalités de l'application sans créer de compte.
            </p>
            <button
              onClick={() => navigate('/')}
              className="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 text-sm font-semibold shadow-sm transition-all duration-300 hover:scale-105"
            >
              Retour à l'accueil
            </button>
          </section>

          {/* Grille des demos avec animations d'entrée en cascade */}
          <section className="mb-12">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
              {demos.map((demo, index) => (
                <div
                  key={demo.id}
                  className="bg-white dark:bg-gray-700 rounded-2xl shadow-xl overflow-hidden transition-all duration-500 hover:shadow-2xl hover:-translate-y-2 cursor-pointer border border-gray-200 dark:border-gray-600 animate-slide-in-up"
                  style={{ animationDelay: `${index * 0.1}s` }}  // Délai pour effet cascade
                  onClick={() => handleSelectDemo(demo.id)}
                >
                  <div 
                    className="relative w-full h-64 overflow-hidden group transition-all duration-500"  // Plus de classes bg Tailwind
                    style={{  // Background couleur dynamique et personnalisée
                      backgroundColor: theme === 'light' 
                        ? (demo.lightBg || '#f9fafb')  // Fallback gris clair
                        : (demo.darkBg || '#374151')   // Fallback gris foncé
                    }}
                  >
                    <img
                      src={demo.image}
                      alt={demo.title}
                      className="w-full h-full object-contain transition-all duration-500 group-hover:scale-110"  // object-contain pour éviter le rognage
                      style={{
                        transformOrigin: 'center center'
                      }}
                    />
                    {/* Overlay subtil pour focus sur hover */}
                    <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-10 transition-all duration-300"></div>
                  </div>
                  <div className="p-6">
                    <h3 className="text-xl font-bold text-gray-800 dark:text-gray-100 mb-3 transition-colors duration-300">
                      {demo.title}
                    </h3>
                    <p className="text-gray-600 dark:text-gray-300 mb-4 transition-colors duration-300">
                      {demo.description}
                    </p>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        handleSelectDemo(demo.id);
                      }}
                      className="w-full px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 font-semibold transition-all duration-300 hover:scale-105 animate-bounce-subtle"
                    >
                      Accéder à cette démo
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </section>

        </div>
      </div>
    </div>
  );
}

export default DemoSelection;